import { Schedule } from "../../interfaces/Space"
import "../../styles/layouts/infoschedule.scss"

type Props = {
    schedule: Schedule | undefined
}

const translateWeekdays: any = {
    "monday": "segunda",
    "tuesday": "terça",
    "wednesday": "quarta",
    "thursday": "quinta",
    "friday": "sexta",
    "saturday": "sábado",
    "sunday": "domingo",
}



export default function InfoSchedule({ schedule }: Props) {

    const getSection = (weekDayName: string, weekDay: string[]) => {

        // const scheduleContent = [];

        const getTime = (timeStr: string) => {
            const hour = timeStr.slice(0, 2)
            const minute = timeStr.slice(2);
            return `${hour}h${minute}`
        }


        let weekdayStr = `${translateWeekdays[weekDayName]}: `;
        let hourStr = '';

        for (let i = 0; i < weekDay.length; i += 2) {
            hourStr = `${hourStr}${getTime(weekDay[i])}-${getTime(weekDay[i + 1])}${weekDay[i + 2] ? ',' : ''} `
        }

        return <div key={weekDayName} className="weekday-section">
            <div className="weekday-name">
                {weekdayStr}
            </div>
            <div className="weekday-hour">
                {hourStr}
            </div>
        </div>
    }

    const getSchedule = (sch: Schedule | undefined) => {

        if (!sch) return;

        const res = [];

        for (const weekDayName of Object.keys(sch)) {

            const weekDayContent = sch[weekDayName as keyof Schedule];

            if (weekDayContent && weekDayContent.length > 0) {
                res.push(getSection(
                    weekDayName,
                    weekDayContent
                ))
            }

        }

        return res;
    }

    return <div className="schedule-container">
        {getSchedule(schedule)}
    </div>
}